import type { FormFieldType } from '@hcc/types';
import { ModalShell } from '../../ui/ModalShell';
import { FIELD_TYPE_META, PALETTE_GROUPS } from './fieldMeta';

interface FieldPaletteProps {
  onPick: (type: FormFieldType) => void;
  onClose: () => void;
}

/** Modal grid of field types to add, grouped by category. */
export function FieldPalette({ onPick, onClose }: FieldPaletteProps) {
  const byGroup = PALETTE_GROUPS.map((group) => ({
    group,
    items: Object.values(FIELD_TYPE_META).filter((m) => m.group === group),
  }));

  return (
    <ModalShell open onClose={onClose} titleId="field-palette-title" maxWidth="max-w-xl">
      <h2 id="field-palette-title" className="mb-3 text-base font-semibold text-fg">
        Add a field
      </h2>
      <div className="max-h-[60vh] space-y-4 overflow-y-auto pr-1">
        {byGroup.map(({ group, items }) => (
          <div key={group}>
            <div className="mb-1.5 text-xs font-medium uppercase tracking-wide text-fg-dim">{group}</div>
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
              {items.map((m) => {
                const Icon = m.icon;
                return (
                  <button
                    key={m.type}
                    type="button"
                    onClick={() => onPick(m.type)}
                    className="flex items-start gap-2 rounded-token-sm border border-line/10 bg-surface p-2.5 text-left hover:border-accent hover:bg-surface-2"
                  >
                    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
                    <span>
                      <span className="block text-sm font-medium text-fg">{m.label}</span>
                      <span className="block text-xs text-fg-dim">{m.hint}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </ModalShell>
  );
}
